var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    transform: "rotate(45 6.156 8.033)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.412,
    height: 2.235,
    y: 5.588,
    fill: "#F30202",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74C3C",
    d: "M5.588 12.412V1a1 1 0 0 1 1-1h.236a1 1 0 0 1 1 1v11.412a1 1 0 0 1-1 1h-.236a1 1 0 0 1-1-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c0964269659ade39c3af82178b74ad6b.svg";
export { ForwardRef as ReactComponent };